import React from 'react';
import { motion } from 'framer-motion';
export function HookSection() {
  return <section className="py-12 md:py-24 px-4 md:px-6 bg-navy-800 border-y border-white/5" data-id="element-65">
      <div className="max-w-3xl mx-auto text-center" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center" data-id="element-67">
          <svg className="w-10 h-10 md:w-12 md:h-12 text-gold-500 mb-5 md:mb-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-68">
            <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" data-id="element-69"></rect>
            <line x1="7" y1="2" x2="7" y2="22" data-id="element-70"></line>
            <line x1="17" y1="2" x2="17" y2="22" data-id="element-71"></line>
            <line x1="2" y1="12" x2="22" y2="12" data-id="element-72"></line>
            <line x1="2" y1="7" x2="7" y2="7" data-id="element-73"></line>
            <line x1="2" y1="17" x2="7" y2="17" data-id="element-74"></line>
            <line x1="17" y1="17" x2="22" y2="17" data-id="element-75"></line>
            <line x1="17" y1="7" x2="22" y2="7" data-id="element-76"></line>
          </svg>

          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-5 md:mb-8" data-id="element-77">
            Seamos honestos: el mercado de la educación digital ha cambiado.
          </h2>

          <div className="space-y-4 md:space-y-6 text-base md:text-lg text-gray-300 font-light leading-relaxed text-left" data-id="element-78">
            <p data-id="element-79">
              Hoy, si tus videos no son visualmente estimulantes, simplemente
              eres ruido de fondo. Puedes tener el mejor consejo del mundo, pero
              si tu "envase" es aburrido, la gente te saltará en 3 segundos.
            </p>
            <p data-id="element-80">
              Estás a un clic de distancia de que tu contenido pase de ser "uno
              más del montón" a verse como una producción de presupuesto
              millonario.
            </p>
            <p className="text-lg md:text-xl text-gold-500 font-medium text-center mt-5 md:mt-8" data-id="element-81">
              La pregunta es: ¿estás listo para dejar de ser ignorado?
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}